import { Radio, RadioGroup } from '@blueprintjs/core'
import React from 'react'
import FrequencyParams = Models.FrequencyParams
import Frequency = Models.Frequency

import { FrequenciesList } from '../../util/contstants'

interface FrequencySelectRadiosProps {
    params: FrequencyParams
    onChange: (v: Frequency) => void
}

/**
 * Renders a group of radio buttons to choose the frequency
 * (either once per day or after every data sync)
 *
 * @param {object} params
 * @param {function} onChange
 * @constructor
 */
export const FrequencySelectRadios = ({ params, onChange }: FrequencySelectRadiosProps) => {
    console.log('onChange passed to FrequencySelectRadios', onChange)
    return (
        <RadioGroup
            selectedValue={params?.frequency}
            className="mb-3"
            onChange={(e: any) => onChange(parseInt(e.target.value))}
        >
            <Radio
                className="mb-0"
                label="After ever data sync (4x per day)"
                value={FrequenciesList.AfterEveryDataSync}
            />
            <Radio className="mb-0" label="Once per day" value={FrequenciesList.OncePerDay} />
        </RadioGroup>
    )
}
